
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          <div className="md:col-span-1">
            <div className="flex flex-col items-start gap-4 mb-6">
              <div className="w-[120px] h-[120px] flex items-center justify-center flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/07ad7141c311a7160b38f0cefce25ed0/fff9872d1e4dea0a924b1029418952c7.png"
                  alt="Dr. Savai Consulting Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-2xl font-bold">Dr. Savai Consulting</span>
            </div>
            <p className="text-gray-100 text-sm leading-relaxed">
              Empowering businesses to unlock the full potential of AI through expert prompting training.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Explore</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-100 hover:text-white transition-colors text-sm cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Training Programs
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-100 hover:text-white transition-colors text-sm cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-100 text-sm">
            © 2025 PromptMastery. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-100 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
